import { 
  FiHome, 
  FiUsers, 
  FiActivity, 
  FiTrendingUp, 
  FiClock, 
  FiDollarSign, 
  FiAward, 
  FiAlertCircle 
} from 'react-icons/fi';

/**
 * Get parent menu items
 * This is a reusable configuration that can be used across all parent pages
 * Follows DRY principle - single source of truth for parent navigation
 * 
 * Mobile-first responsive sidebar navigation
 */
export const getParentMenuItems = () => [
  { icon: <FiHome />, label: 'Dashboard', path: '/parent' },
  { icon: <FiUsers />, label: 'Students', path: '/parent/students' },
  { icon: <FiActivity />, label: 'Learning Intelligence', path: '/parent/learning-intelligence' },
  { icon: <FiTrendingUp />, label: 'Performance', path: '/parent/performance' },
  { icon: <FiClock />, label: 'Engagement', path: '/parent/engagement' },
  { icon: <FiDollarSign />, label: 'ROI Metrics', path: '/parent/roi' },
  { icon: <FiAward />, label: 'Comparative', path: '/parent/comparative' },
  { icon: <FiAlertCircle />, label: 'Insights', path: '/parent/insights' },
];

